import { Spacing, Text } from '@vkontakte/vkui';
import React, { memo, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { cdnPackagesUrl } from 'reactApp/appHelpers/themeToolHelpers/default-values';
import { historyPush } from 'reactApp/modules/router/router.module';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { isCurrentDarkTheme } from 'reactApp/modules/theme/theme.selectors';
import { Button, ButtonSizeMode } from 'reactApp/ui/Button/Button';
import { sendXray } from 'reactApp/utils/ga';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';

import styles from './DuplicatesRemovedEmptyState.css';

const text = {
    title: 'Все\u00A0дубликаты\u00A0— в\u00A0корзине',
    description1: 'Вы\u00A0можете вернуть их\u00A0в\u00A0течение 14\u00A0дней\u00A0—',
    description2: 'потом фото удалятся навсегда',
    button: 'Перейти в\u00A0корзину',
};

export const DuplicatesRemovedEmptyState = memo(function DuplicatesRemovedEmptyState() {
    const isDark = useSelector(isCurrentDarkTheme);
    const imgSrc = `${cdnPackagesUrl}/static/cloud/empty/duplicates_removed${isDark ? '_dark' : ''}.webp`;

    const dispatch = useDispatch();

    const handleButtonClick = useCallback(() => {
        dispatch(historyPush({ id: `/${EStorageType.trashbin}` }));
    }, []);

    useEffect(() => {
        sendXray(['dp-empty-state', '2', 'show']);

        sendPaymentGa({
            eventCategory: ECategoryGa.duplicates,
            action: 'empty-state-show',
            empty_state_type: 'all-duplicates-in-trash',
        });
    }, []);

    return (
        <div className={styles.wrapper} data-qa-id="duplicates-removed-empty">
            <div className={styles.container}>
                <img src={imgSrc} className={styles.img} alt="" />
                <div className={styles.textContainer}>
                    <span className={styles.title}>{text.title}</span>
                    <Spacing size={12} />
                    <Text className={styles.text}>
                        {text.description1}
                        <br />
                        {text.description2}
                    </Text>
                    <Spacing size={24} />
                    <Button
                        onClick={handleButtonClick}
                        sizeMode={ButtonSizeMode.small}
                        primary
                        theme="octavius"
                        qaId="duplicates-removed-empty-button"
                    >
                        {text.button}
                    </Button>
                </div>
            </div>
        </div>
    );
});
